import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Routes, { isEnterpriseUrl } from '../../Routes';
import User from '../../models/User';
import { TopBarVisibility } from './TopBarVisibility';
import { sessionCheck } from 'src/actions/user';

export class Container extends React.Component {

  constructor(props){
    super(props)
    props.sessionCheck(false)
  }

  render () {
    const { user, location } = this.props;
    let viewing = null;
    if (user) {
      if (TopBarVisibility.isViewingAs(user)) {
        viewing = User.getEmail(user) || 'Not Available';
      }
    }
    const containerClass = !!viewing ? 'container-padding-viewing-as' : 'container-padding';
    const orgDashboardClass = isEnterpriseUrl(location.pathname) ? 'org-dash' : '';
    return (
      <div
        className={ `${containerClass} ${orgDashboardClass}` }>
        { !!viewing && <div className="viewing-as-banner fixed-top">ATTENTION: Viewing as { viewing }</div> }
        { Routes }
      </div>
    );
  }
}

export const mapStateToProps = (state) => ({
  user: state.user.user,
  userError: state.user.error
});

export default withRouter(connect(mapStateToProps, {
  sessionCheck
})(Container));

